<template>
  <div id="layout-top-nav" class="layout-top-nav layout-fixed layout-navbar-fixed animated fadeIn">
    <div class="navbar-space"></div>
    <div class="wrapper">
      <navbar></navbar>

      <div class="content-wrapper pt-4">
        <div class="content-header" style="margin-bottom: 0px;">
          <slot name="header"></slot>
        </div>

        <div class="content">
          <div class="container-fluid" id="top">
            <slot name="content"></slot>
          </div>
        </div>
      </div>
    </div>
    <footer class="main-footer ml-0 text-right">
      <a href="http://i9ss.com.br" target="_blank">Inove Sistemas e Soluções Empresariais</a>
      &nbsp;&copy; {{ anoAtual }} -
      &nbsp;<strong>{{ $t('versao') }}</strong>: 1.0006
    </footer>
  </div>
</template>

<script>
import Navbar from '@/components/NavBar/Navbar'

export default {
  components: {
    Navbar
  },

  data () {
    return {
      isSidebarOpen: false,
      breadcrumbItems: [
        {
          text: 'Ordens de Serviço',
          href: '/os'
        },
        {
          text: `OS #${this.$route.params.id}`,
          active: true
        }
      ]
    }
  },

  computed: {
    anoAtual () {
      return this.$store.state.anoAtual
    }
  }
}
</script>

<style lang="scss" scoped>
.icon--custom {
  top: 50px;
}

</style>
